import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL_admin}/dashboard`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');
    if (token) headers.set('authorization', `Bearer ${token}`);
    return headers;
  },
});

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery,
  endpoints: (builder) => ({
    dashboardOverview: builder.query({
      query: ({ sorgcode, startDate, endDate }) => {
        const params = new URLSearchParams({ sorgcode, startDate, endDate });
        return `/overview?${params.toString()}`;
      },
    }),
  }),
});

export const { useDashboardOverviewQuery } = dashboardApi;
